import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import { Switch, Route, Redirect } from 'react-router-dom';
// core components
import Sidebar from 'components/Layout/Sidebar';
import Navbar from 'components/Layout/Navbar';
import dashboardRoutes from 'routes/dashboard';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from 'assets/jss/Layout';
import GraphqlViewErrorBoundary from 'components/common/GraphqlViewErrorBoundary';
import ErrorView from 'helpers/errorViewHelper';
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import WithPermission from 'components/User/WithPermission';
import { DASHBOARD } from 'routes/paths';

const switchRoutes = (
  <Switch>
    {dashboardRoutes.map(route => {
      if (route.base) {
        return (
          route.views &&
          route.views.map(child => {
            if (child.redirect) {
              return (
                <Redirect
                  from={child.path}
                  to={child.pathTo}
                  key={child.name}
                />
              );
            }

            let childRoute = (
              <Route
                path={child.path}
                component={child.component}
                key={`route-${child.name}`}
                exact
              />
            );

            if (child.allowPermissions) {
              childRoute = (
                <Route
                  path={child.path}
                  render={(props) => (
                    <WithPermission
                      allowPermissions={child.allowPermissions}
                      alt={<ErrorView message="Permiso denegado" />}
                    >
                      <child.component {...props}/>
                    </WithPermission>
                  )}
                  key={`route-${child.name}`}
                  exact
                />
              );
            }

            return childRoute;
          })
        );
      }

      let resultRoute = (
        <Route
          path={route.path}
          component={route.component}
          key={`route-${route.name}`}
          exact
        />
      );

      if (route.allowPermissions) {
        resultRoute = (
          <Route
            path={route.path}
            render={(props) => (
              <WithPermission
                allowPermissions={route.allowPermissions}
                alt={<ErrorView message="Permiso denegado" />}
              >
                <route.component {...props}/>
              </WithPermission>
            )}
            key={`route-${route.name}`}
            exact
          />
        );
      }
      return resultRoute;
    })}
    <Redirect from="/" to={DASHBOARD} key="route-entrypoint"/>
  </Switch>
);

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
    };
  }

  handleShowMenu = () => {
    const { menuIsOpen } = this.state;
    this.setState({ menuIsOpen: !menuIsOpen });
  };

  render() {
    const { menuIsOpen } = this.state;
    const { classes } = this.props;
    return (
      <div style={{ padding: '0 15px' }}>
        <GridContainer style={{ backgroundColor: '#F7F7F7' }}>
          <GridItem xs={12}>
            <Navbar menuIsOpen={menuIsOpen} showMenu={this.handleShowMenu}/>
          </GridItem>
          <GridItem xs={12}>
            <div className={classes.container}>
              <Sidebar open={menuIsOpen} routes={dashboardRoutes} />
              <div
                className={[
                  classes.content,
                  menuIsOpen && classes.sideMenuOpen,
                ].join(' ')}
              >
                <GraphqlViewErrorBoundary>
                  {switchRoutes}
                </GraphqlViewErrorBoundary>
              </div>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(Dashboard);
